export default {
    disputas: [],
}